import {QUIKLEARN_BACKEND_URL, API_KEY} from 'config/app.config';
import mockLesson720L from './mockData/lesson-720L.json';

const MOCK_DATA = {
  'G3-MATH-L001-720L': mockLesson720L,
};

function isMockMode() {
  if (typeof window === 'undefined') return false;
  const params = new URLSearchParams(window.location.search);
  return params.get('useMock') === 'true';
}

const getBaseUrl = () => String(QUIKLEARN_BACKEND_URL || '').replace(/\/$/, '');

export async function fetchLessonContent(lessonId) {
  if (isMockMode()) {
    const mock = MOCK_DATA[lessonId];
    if (!mock) {
      throw new Error(`No mock data for lessonId: ${lessonId}`);
    }
    console.log('[LessonContentService] Using mock data for', lessonId);
    return {content: mock};
  }

  const base = getBaseUrl();
  const url = `${base}/api/lesson-content/${lessonId}?includeContent=true`;

  const response = await fetch(url, {
    headers: {
      'x-api-key': API_KEY,
    },
  });

  if (!response.ok) {
    const status = response.status;
    if (status === 404) {
      throw new Error(`Lesson not found: ${lessonId}`);
    }
    throw new Error(`Failed to fetch lesson content (${status})`);
  }

  return response.json();
}
